import { render } from "./NotFound.vue?vue&type=template&id=64d866da&scoped=true&bindings={}"
import script from "./NotFound.vue?vue&type=script&lang=js"
export * from "./NotFound.vue?vue&type=script&lang=js"

import "./NotFound.vue?vue&type=style&index=0&id=64d866da&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-64d866da"

export default script